import "../src/assets/css/style.css";

import { ActivityIndicator, Linking, StyleSheet, Text, TextInput, View } from "react-native";
import Animated, { useAnimatedStyle, useSharedValue } from "react-native-reanimated";
import { FIREBASE_EVENT_NAMES, FIREBASE_EVENT_PARAMS, PAGES_ROUTES, PAGES_TITLE } from "utils/Constants";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { router, useLocalSearchParams } from "expo-router";
import { showSuccess, showToast } from "src/utils/ToastUtils";
import { useDispatch, useSelector } from "react-redux";

import Buttons from "components/Buttons";
import { Colors } from "colors";
import ListView from "components/ListView";
import ParentScrollView from "components/ParentScrollView";
import PaymentCardsComp from "src/components/profile/paymentCardsComp";
import SideProfileComp from "components/profile/SideProfileComp";
import { TouchableOpacity } from "react-native";
import VText from "components/VText";
import { analytics } from "utils/firebaseConfig";
import { getOrderHistory } from "appRedux/reducers/orderSlice";
import { getUserAddressList } from "appRedux/reducers/orderSlice";
import { logEvent } from "firebase/analytics";
import { saveUserCard } from "src/redux/reducers/profileSlice";
import { svg } from "assets/svg";
import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import { trackV2 } from "utils/Segment";

const FloatingLabelInput = ({ label, value, onChange, placeholder, maxLength, isError, message, regex }) => {
    return (
        <div style={{ position: "relative", marginBottom: "20px", width: "-webkit-fill-available", zIndex: "-99999" }}>
            <input
                type="text"
                value={value}
                className={`floating-label-input ${isError ? "input-error" : ""}`}
                onChange={onChange}
                placeholder={placeholder}
                maxLength={maxLength}
                pattern={regex}
                style={{
                    width: "-webkit-fill-available",
                    padding: 16,
                    border: `1px solid ${isError ? "#E20E0E" : "#21242799"}`,
                    outline: "none",
                    borderRadius: 4,
                    fontFamily: "JosefinSans",
                    fontSize: fp(16),
                    color: isError ? "#E20E0E" : "#999",
                    backgroundColor: "white",
                }}
            />
            <label
                style={{
                    position: "absolute",
                    paddingLeft: 10,
                    paddingRight: 10,
                    top: "-6px",
                    left: "15px",
                    fontFamily: "JosefinSans",
                    fontSize: fp(16),
                    color: isError ? "#E20E0E" : "#999",
                    transition: "0.2s ease all",
                    pointerEvents: "none",
                    backgroundColor: "white",
                }}
            >
                {label}
            </label>
            {message && (
                <VText style={{ color: "#E20E0E", fontSize: fp(14), fontFamily: "JosefinSans", marginTop: spV(5) }}>
                    {message}
                </VText>
            )}
        </div>
    );
};

const SimpleLabelInput = ({ label, value, onChange, placeholder, maxLength, isEr, errorMessage, regex }) => {
    let isError = errorMessage?.length > 0 ? true : false;
    return (
        <div style={{ marginBottom: "18px", width: "-webkit-fill-available", zIndex: "-99999" }}>
            <label
                style={{
                    fontFamily: "JosefinSans",
                    fontSize: fp(16),
                    color: isError ? "#E20E0E" : "#999",
                    transition: "0.2s ease all",
                    pointerEvents: "none",
                    backgroundColor: "white",
                    fontWeight: "350",
                }}
            >
                {label}
            </label>
            <input
                type="text"
                value={value}
                className={`floating-label-input ${isError ? "input-error" : ""}`}
                onChange={onChange}
                placeholder={placeholder}
                maxLength={maxLength}
                pattern={regex}
                style={{
                    marginTop: "8px",
                    width: "-webkit-fill-available",
                    padding: wp(14),
                    border: `1px solid ${isError ? "#E20E0E" : "#21242799"}`,
                    outline: "none",
                    borderRadius: 0,
                    fontFamily: "JosefinSans",
                    fontSize: fp(16),
                    fontWeight: "350",
                    color: isError ? "#E20E0E" : "#333333",
                    backgroundColor: "white",
                }}
            />

            {errorMessage && (
                <VText style={{ color: "#E20E0E", fontSize: fp(13), fontFamily: "JosefinSans", marginTop: spV(5) }}>
                    {errorMessage}
                </VText>
            )}
        </div>
    );
};

const ManageSavedCards = () => {
    const [isLoading, setLoader] = useState(false);
    const [isError, setIsError] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const dropdownRef = useRef(null);
    const [showOptions, setShowOptions] = useState(false);
    const [errorMessage, setErrorMessage] = useState({
        address: "",
        cardNumber: "",
        securityCode: "",
        expiryDate: "",
        cvv: "",
        zipCode: "",
        generalError: "",
    });

    const [cardDetails, setCardDetails] = useState({
        cardNumber: "",
        cardNumberMask: "",
        cardType: "",
        expiryDate: "",
        cvv: "",
        cardHolderName: "",
        zipCode: "",
    });
    const local = useLocalSearchParams();
    const gender = local?.gender || "female";
    const addressId = local?.addressId || null;
    const userId = useSelector((state) => state.AuthReducer.userId);
    const userAddressList = useSelector((state) => state.OrderReducer.userAddressList);
    const [selectedOption, setSelectedOption] = useState(
        addressId ? userAddressList.find((address) => address.id === addressId) : null
    );
    const dispatch = useDispatch();

    useEffect(() => {
        logEvent(analytics, FIREBASE_EVENT_NAMES.PAGE_VIEW, {
            [FIREBASE_EVENT_PARAMS.PAGE_TITLE]: PAGES_TITLE.ORDER_HISTORY,
            [FIREBASE_EVENT_PARAMS.PAGE_LOCATION]: PAGES_ROUTES.ORDER_HISTORY,
        });
        dispatch(getUserAddressList());
    }, []);

    useEffect(() => {
        if (addressId) {
            setSelectedOption(userAddressList.find((address) => address.id === addressId));
            // setCardDetails({...cardDetails,zipCode:selectedOption?.pincode})
        }
    }, [addressId, userAddressList]);

    const detectCardType = (number) => {
        const cardTypes = [
            { regex: /^3[47]\d{0,13}$/, cardType: "american express", mask: "0000 000000 00000" },
            { regex: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}$/, cardType: "discover", mask: "0000 0000 0000 0000" },
            { regex: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}$/, cardType: "diners", mask: "0000 000000 0000" },
            {
                regex: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}$/,
                cardType: "mastercard",
                mask: "0000 0000 0000 0000",
            },
            { regex: /^(?:2131|1800)\d{0,11}$/, cardType: "jcb15", mask: "0000 000000 00000" },
            { regex: /^(?:35\d{0,2})\d{0,12}$/, cardType: "jcb", mask: "0000 0000 0000 0000" },
            { regex: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}$/, cardType: "maestro", mask: "0000 0000 0000 0000" },
            { regex: /^4\d{0,15}$/, cardType: "visa", mask: "0000 0000 0000 0000" },
            { regex: /^62\d{0,14}$/, cardType: "unionpay", mask: "0000 0000 0000 0000" },
        ];

        for (let i = 0; i < cardTypes.length; i++) {
            if (number.match(cardTypes[i].regex)) {
                return cardTypes[i];
            }
        }
        return { cardType: "Unknown", mask: "0000 0000 0000 0000 000" };
    };

    const applyMask = (number, mask) => {
        let cleaned = number.replace(/\D+/g, "");
        let formatted = "";
        let maskIndex = 0;
        for (let i = 0; i < cleaned.length; i++) {
            if (maskIndex >= mask.length) {
                break;
            }
            if (mask[maskIndex] === "0") {
                formatted += cleaned[i];
                maskIndex++;
            } else {
                formatted += mask[maskIndex];
                maskIndex++;
                i--;
            }
        }
        return formatted;
    };

    const handleSaveCard = async () => {
        setErrorMessage({});

        const validateCardDetails = () => {
            const errors = {};

            if (!selectedOption) {
                errors.address = "Select or Add New Address before proceeding";
            }
            if (cardDetails.cardNumber.length < 13 || cardDetails.cardNumber.length > 19) {
                errors.cardNumber = "Please enter a valid Card Number";
            }

            const expiryParts = cardDetails.expiryDate.split("/");
            const expiryMonth = parseInt(expiryParts[0], 10);
            const expiryYear = parseInt(`20${expiryParts[1]}`, 10);
            const currentDate = new Date();
            const expiryDate = new Date(expiryYear, expiryMonth - 1);

            // Adjust the currentDate to the start of the month for comparison
            const currentMonthStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

            if (cardDetails.expiryDate.length !== 5 || expiryMonth > 12 || expiryDate < currentMonthStart) {
                errors.expiryDate = "Please enter a valid Expiry Date in MM/YY format and ensure it's not a past date";
            }

            if (cardDetails.cvv.length < 3 || cardDetails.cvv.length > 4 || !/^\d+$/.test(cardDetails.cvv)) {
                errors.cvv = "Please enter a valid Security Code (3-4 digits)";
            }

            if (!cardDetails?.zipCode) {
                errors.zipCode = "Zip Code cannot be empty";
            }

            if (cardDetails.cardHolderName.length < 3) {
                errors.cardHolderName = "Please enter a valid Card Holder Name";
            }

            return errors;
        };

        const errors = validateCardDetails();
        if (Object.keys(errors).length > 0) {
            setErrorMessage(errors);
            return;
        }

        const firstName = selectedOption?.name?.split(" ")[0];
        const lastName = selectedOption?.name?.split(" ").length > 1 ? selectedOption?.name?.split(" ")[1] : "";

        const payload = {
            userId: userId,
            firstName: firstName,
            lastName: lastName,
            address: selectedOption?.addressLine1 + ", " + selectedOption?.addressLine2,
            city: selectedOption?.city,
            state: selectedOption?.state,
            country: "USA",
            phoneNumber: selectedOption?.mobileNumber,
            cardNumber: cardDetails.cardNumber.replace(/\s+/g, ""),
            nameOnCard: cardDetails.cardHolderName,
            validThru: cardDetails.expiryDate.replace(/(\d{2})$/, "20$1"),
            securityCode: cardDetails.cvv.toString(),
            zipcode: cardDetails.zipCode.toString(),
        };
        setLoader(true);
        setIsError(false);

        dispatch(saveUserCard(payload))
            .then((res) => {
                if ([200].includes(res?.payload?.status)) {
                    setLoader(false);
                    showSuccess("Card Saved Successfully");
                    const cardType = detectCardType(cardDetails.cardNumber.replace(/\s+/g, ""));
                    const eventData = {
                        card_type: cardType?.cardType,
                    };
                    trackV2(ANALYTICS_EVENT_NAMES.NEW_CARD_ADDED, eventData);
                    setIsError(false);
                    router.push(`${gender == 'men' ? '/men' : ''}/manage-saved-cards`);
                } else {
                    let error = res?.payload?.data;

                    setErrorMessage({ generalError: error });
                    setIsError(true);
                    setLoader(false);
                    alert(error);
                }
            })
            .catch((err) => {
                console.log("err", err);
                setLoader(false);
                showToast("Error saving card");
                setIsError(true);
            });
    };
    const rotate2 = useSharedValue(0);
    const animatedStyles2 = useAnimatedStyle(() => ({
        transform: [{ rotateZ: `${rotate2.value}deg` }],
    }));

    return (
        <ParentScrollView>
            <View style={styles.container}>
                <VText style={styles.subHeader}>Manage Saved Cards</VText>
                <VText style={styles.header}>Add New Card</VText>
                <View style={styles.content}>
                    <SideProfileComp gender={gender} selected="Manage Saved Cards" />
                    <View style={styles.orderHistorySection}>
                        <View
                            style={{
                                borderWidth: 1,
                                borderColor: "#00000033",
                                padding: 16,
                                marginTop: 16,
                                flexDirection: "row",
                                alignItems: "center",
                                height: hp(100),
                            }}
                            activeOpacity={1}
                        >
                            <Svg
                                width="28"
                                height="28"
                                viewBox="0 0 28 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <G clipPath="url(#clip0_8468_45094)">
                                    <Path
                                        d="M28 5.73279V22.2673C28 23.3336 27.1353 24.1983 26.069 24.1983H1.93103C0.864741 24.1983 0 23.3336 0 22.2673V5.73279C0 4.6665 0.864741 3.80176 1.93103 3.80176H26.069C27.1353 3.80176 28 4.6665 28 5.73279Z"
                                        fill="#ADC6FF"
                                    />
                                    <Path
                                        d="M7.96336 17.2585H3.92026C3.65365 17.2585 3.4375 17.0423 3.4375 16.7757C3.4375 16.5091 3.65365 16.293 3.92026 16.293H7.96336C8.22996 16.293 8.44611 16.5091 8.44611 16.7757C8.44611 17.0423 8.22996 17.2585 7.96336 17.2585Z"
                                        fill="white"
                                    />
                                    <Path
                                        d="M7.96336 20.2761H3.92026C3.65365 20.2761 3.4375 20.0599 3.4375 19.7933C3.4375 19.5267 3.65365 19.3105 3.92026 19.3105H7.96336C8.22996 19.3105 8.44611 19.5267 8.44611 19.7933C8.44611 20.0599 8.22996 20.2761 7.96336 20.2761Z"
                                        fill="white"
                                    />
                                    <Path
                                        d="M25.1011 18.2842C25.1011 19.4175 24.1827 20.336 23.0494 20.336C22.4526 20.336 21.9155 20.0813 21.5408 19.6746C20.2833 21.0393 17.9805 20.1534 17.9805 18.2842C17.9805 16.4128 20.2845 15.5303 21.5408 16.8939C21.9155 16.4872 22.4526 16.2325 23.0494 16.2325C24.1827 16.2325 25.1011 17.151 25.1011 18.2842Z"
                                        fill="#F4B619"
                                    />
                                    <Path
                                        d="M20.0322 20.3359C21.1653 20.3359 22.0839 19.4173 22.0839 18.2841C22.0839 17.151 21.1653 16.2324 20.0322 16.2324C18.8991 16.2324 17.9805 17.151 17.9805 18.2841C17.9805 19.4173 18.8991 20.3359 20.0322 20.3359Z"
                                        fill="#EE7212"
                                    />
                                    <Path d="M0 8.14648H28V12.2499H0V8.14648Z" fill="#5585F8" />
                                </G>
                                <Defs>
                                    <ClipPath id="clip0_8468_45094">
                                        <Rect width="28" height="28" fill="white" />
                                    </ClipPath>
                                </Defs>
                            </Svg>

                            <VText
                                style={{
                                    fontSize: fp(16),
                                    fontWeight: "550",
                                    color: "#333333",
                                    paddingLeft: 15,
                                }}
                            >
                                Credit / Debit Card
                                <VText
                                    style={{ fontSize: fp(16), color: "#212427B2", display: "block", paddingTop: 10 }}
                                >
                                    Pay with your preferred Credit/Debit Card
                                </VText>
                            </VText>
                        </View>
                        <View>
                            <View ref={dropdownRef} style={styles.selectContainer}>
                                <TouchableOpacity
                                    onPress={() =>
                                        setShowOptions((prev) => {
                                            if (prev == true) {
                                                rotate2.value = 0;
                                                return false;
                                            } else {
                                                rotate2.value = 180;
                                                return true;
                                            }
                                        })
                                    }
                                    style={{
                                        ...styles.dropdownButton,
                                        borderColor: errorMessage?.address ? "#E20E0E" : "#21242799",
                                    }}
                                >
                                    <VText
                                        style={{
                                            fontSize: fp(16),
                                            fontWeight: "350",
                                            color: errorMessage?.address
                                                ? "#E20E0E"
                                                : selectedOption
                                                ? "#212427"
                                                : "#212427B2",
                                        }}
                                    >
                                        {selectedOption
                                            ? `${selectedOption?.addressLine1}, ${selectedOption?.addressLine2}, ${selectedOption?.city}, ${selectedOption?.state}-${selectedOption?.pincode}`
                                            : "Select or Add New Address associated with this Card"}
                                    </VText>

                                    <Animated.View style={[animatedStyles2]}>
                                        <Svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <Path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M4 8.29936L5.29936 7L12 13.7006L18.7006 7L20 8.29936L12 16.2994L4 8.29936Z"
                                                fill={
                                                    errorMessage?.address
                                                        ? "#E20E0E"
                                                        : selectedOption
                                                        ? "#212427"
                                                        : "#212427B2"
                                                }
                                            />
                                        </Svg>
                                    </Animated.View>
                                </TouchableOpacity>

                                {showOptions && (
                                    <View style={styles.optionsContainer}>
                                        {userAddressList.map((option, index) => (
                                            <TouchableOpacity
                                                onPress={() => {
                                                    setSelectedOption(option);
                                                    setCardDetails({ ...cardDetails, zipCode: option.pincode });
                                                    setShowOptions((prev) => {
                                                        rotate2.value = 0;
                                                        return false;
                                                    });
                                                }}
                                                style={styles.pickerItem}
                                            >
                                                <VText style={{ fontSize: fp(14), fontWeight: "350" }}>
                                                    {`${option.addressLine1}, ${option.addressLine2}, ${option.city}, ${option.state}-${option.pincode}`}
                                                </VText>
                                            </TouchableOpacity>
                                        ))}
                                        <TouchableOpacity
                                            onPress={() => {
                                                router.push(`${gender == 'men' ? '/men' : ''}/add-address?redirectTo=add-card&isProfile=true`);
                                            }}
                                            style={styles.pickerItem}
                                        >
                                            <VText style={{ fontSize: fp(14), fontWeight: "600", color: "#212427" }}>
                                                + Add New Address
                                            </VText>
                                        </TouchableOpacity>
                                    </View>
                                )}
                            </View>
                            {errorMessage?.address && (
                                <VText
                                    style={{
                                        color: "#E20E0E",
                                        fontSize: fp(14),
                                        fontFamily: "JosefinSans",
                                        marginTop: spV(5),
                                        zIndex: "-1",
                                    }}
                                >
                                    {errorMessage.address}
                                </VText>
                            )}
                        </View>
                        <View style={{ marginTop: spV(20), zIndex: "-1" }}>
                            <SimpleLabelInput
                                isError={isError}
                                errorMessage={errorMessage?.cardNumber}
                                placeholder="xxxx xxxx xxxx xxxx"
                                label="Card Number"
                                value={cardDetails?.cardNumber}
                                onChange={(e) => {
                                    const cleanedNumber = e.target.value.replace(/\D+/g, ""); // Remove non-numeric characters
                                    const detectedCard = detectCardType(cleanedNumber);
                                    const maskedCardNumber = applyMask(cleanedNumber, detectedCard.mask);
                                    setCardDetails({ ...cardDetails, cardNumber: maskedCardNumber });
                                }}
                            />
                            <SimpleLabelInput
                                placeholder="John Doe"
                                regex="^[a-zA-Z ]+$"
                                label="Name on Card"
                                value={cardDetails.cardHolderName}
                                onChange={(e) => setCardDetails({ ...cardDetails, cardHolderName: e.target.value })}
                            />

                            <View
                                style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    gap: 30,
                                    justifyContent: "space-around",
                                }}
                            >
                                <SimpleLabelInput
                                    errorMessage={errorMessage?.expiryDate}
                                    isError={isError}
                                    placeholder="MM/YY"
                                    label="Expiry Date"
                                    value={cardDetails.expiryDate}
                                    onChange={(e) => {
                                        const cleaned = e.target.value.replace(/\D+/g, "");
                                        let month = cleaned.substring(0, 2);
                                        let year = cleaned.substring(2, 4);
                                        setCardDetails({ ...cardDetails, expiryDate: `${month}/${year}` });
                                    }}
                                />
                                <SimpleLabelInput
                                    errorMessage={errorMessage?.cvv}
                                    isError={isError}
                                    placeholder="XXX"
                                    regex="^[0-9]{3}$"
                                    label="Security Code"
                                    value={cardDetails.cvv}
                                    maxLength={4}
                                    onChange={(e) => {
                                        const cleaned = e.target.value.replace(/\D+/g, "");
                                        setCardDetails({ ...cardDetails, cvv: cleaned });
                                    }}
                                />
                            </View>

                            <SimpleLabelInput
                                errorMessage={errorMessage?.zipCode}
                                isError={isError}
                                placeholder="000000"
                                regex="^[0-9]{6}$"
                                label="Zip Code"
                                value={cardDetails.zipCode}
                                maxLength={6}
                                onChange={(e) => {
                                    const cleaned = e.target.value.replace(/\D+/g, "");
                                    setCardDetails({ ...cardDetails, zipCode: cleaned });
                                }}
                            />

                            {errorMessage?.generalError && (
                                <VText
                                    style={{
                                        color: "#E20E0E",
                                        fontSize: fp(13),
                                        fontFamily: "JosefinSans",
                                        marginTop: spV(5),
                                        zIndex: "-1",
                                    }}
                                >
                                    {errorMessage.generalError}
                                </VText>
                            )}
                            <Buttons
                                disabled={
                                    !cardDetails.cardNumber ||
                                    !cardDetails.cardHolderName ||
                                    !cardDetails.expiryDate ||
                                    !cardDetails.cvv ||
                                    !cardDetails.zipCode ||
                                    !selectedOption
                                }
                                text={"Save Card"}
                                noBorder={false}
                                loading={isLoading}
                                containerStyle={[
                                    styles.addNewCardButton,
                                    { marginTop: spV(10) },
                                    {
                                        opacity:
                                            !cardDetails.cardNumber ||
                                            !cardDetails.cardHolderName ||
                                            !cardDetails.expiryDate ||
                                            !cardDetails.cvv ||
                                            !cardDetails.zipCode ||
                                            !selectedOption
                                                ? 0.5
                                                : 1,
                                    },
                                ]}
                                onPress={handleSaveCard}
                            />
                            <VText
                                style={{ fontSize: fp(13), fontWeight: "350", color: "#212427B2", marginTop: spV(10) }}
                            >
                                Your card will be saved securely for future purposes.
                            </VText>
                        </View>
                    </View>
                </View>
            </View>
        </ParentScrollView>
    );
};
export default ManageSavedCards;

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: Colors.white,
        paddingTop: spV(32),
    },
    inputLabel: {
        fontSize: fp(14),
        fontWeight: "400",
        marginBottom: spV(10),
    },
    inputField: {
        borderWidth: 1,
        borderColor: "#00000033",
        padding: 10,
        marginTop: spV(10),
    },

    addNewCardButton: {
        width: wp(312),
        height: hp(56),
    },

    header: {
        textAlign: "center",
        fontSize: fp(28),
        fontFamily: "LibreBodoni",
        fontWeight: "400",
        marginBottom: spV(28),
    },

    subHeader: {
        textAlign: "center",
        fontSize: fp(18),
        fontWeight: "600",
        marginBottom: spV(10),
    },

    content: {
        flex: 1,
        flexDirection: "row",
    },
    orderHistorySection: {
        width: wp(652),
        marginHorizontal: spH(80),
    },
    loadingContainer: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
    emptyText: {
        fontFamily: "JosefinSans",
        fontSize: 20,
        fontWeight: "550",
        textAlign: "center",
        marginTop: spV(15),
    },
    emptyContainer: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
    selectContainer: {
        marginTop: spV(20),
        // width: wp(500),
    },
    pickerStyle: {
        borderWidth: 1,
        borderColor: "#2124274D",
    },
    pickerItem: {
        padding: spV(10),
        borderBottomWidth: 1,
        borderBottomColor: "#2124274D",
    },
    dropdownButton: {
        borderWidth: 1,
        borderColor: "#21242799",
        padding: spV(10),
        Width: wp(150),
        flexDirection: "row",
        justifyContent: "space-between",
    },
    selectHeading: {
        fontSize: fp(16),
        fontWeight: "450",
        // marginBottom: spV(10),
    },
    optionsContainer: {
        width: "100%",
        marginTop: spV(10),
        top: hp(30),
        position: "absolute",
        zIndex: 99,
        backgroundColor: "white",
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        elevation: 5,
        paddingHorizontal: spH(10),
        borderWidth: 1,
        borderColor: "#2124274D",
        // overflow: "scroll",
    },
});
